import React from "react";
import { FaShare } from "react-icons/fa";

type Props = {
    value: string | any
}

export default function ShareButton({ value }: Props) {
  let [copied, setCopied] = React.useState(false);



  React.useEffect(() => {
    if (copied) {
      let id = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(id);
    }
  }, [copied]);

  return (
    <button
      className="m-4 rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
      title="Copy url to clipboard for easy sharing"
      onClick={() => {
        navigator.clipboard.writeText(document.location.href).catch(err => console.error(err));
        setCopied(true);
      }}
    >
      {copied ? <span title={document.location.href}><FaShare className="float-left m-1 mr-2" />Copied!</span> : <span><FaShare className="float-left m-1 mr-2" />Copy URL</span>}
    </button>
  );
}

